module.exports = __webpack_public_path__ + "static/media/tdetenido-01.89a73a04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fuel/tdetenido-01.svg
// module id = 708
// module chunks = 0